var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mesh"},[_vm._m(0),_vm._v(" "),_c('svg',{ref:"mesh",attrs:{"id":"mesh"},on:{"click":_vm.clicked}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h1',[_vm._v("App Mesh")])])
}]

export { render, staticRenderFns }